module.exports = __webpack_public_path__ + "static/HOME-BG.6b67f399.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HOME-BG.jpg
// module id = 498
// module chunks = 35783957827783